import { VStack, Text, Input, Button, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { MatchData } from '@/types/match'
import { getMatch } from '@/services/firebase'
import { CenteredPage } from '@/components/layout/CenteredPage'

interface JoinMatchProps {
  onJoin: (data: MatchData) => void
}

export function JoinMatch({ onJoin }: JoinMatchProps) {
  const [matchId, setMatchId] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!matchId.trim()) {
      toast({
        title: 'Error',
        description: 'Please enter a match ID',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      return
    }

    setIsLoading(true)
    try {
      const matchData = await getMatch(matchId)
      if (!matchData) {
        throw new Error('Match not found')
      }
      await onJoin(matchData)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to join match. Please check the match ID and try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <CenteredPage>
        <Text fontSize="2xl" fontWeight="bold" color="white">
          Join Match
        </Text>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <VStack spacing={4} w="100%">
          <Input
              placeholder="Enter Match ID"
            value={matchId}
            onChange={(e) => setMatchId(e.target.value)}
              bg="gray.700"
              color="white"
              _placeholder={{ color: 'gray.400' }}
          />
        <Button
          type="submit"
          colorScheme="blue"
              w="100%"
          isLoading={isLoading}
        >
              Join
        </Button>
          </VStack>
        </form>
    </CenteredPage>
  )
} 